import {
  type OfferListingApi,
  OfferListingApiClient,
} from '@fourthwall/services/dist/OfferListingApiClient'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'
import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

const PAGE_SIZE = 20

export const useOffersListingInfiniteQuery = (
  params?: OfferListingApi.GetOffersListingParams,
  options?: UseInfiniteQueryOptions<OfferListingApi.GetOffersListingResponse>,
) => {
  const query = useInfiniteQuery<OfferListingApi.GetOffersListingResponse>(
    ['offersListingInfinite', params],
    async ({ pageParam = 0 }) => {
      const { data } = await OfferListingApiClient.getOffersListing({
        size: PAGE_SIZE,
        page: pageParam,
        ...params,
      })

      return data
    },
    {
      getNextPageParam: ({ page: { hasNextPage, pageNumber } }) => hasNextPage && pageNumber + 1,
      select: (data) => {
        data.pages[0].offers = data.pages[0].offers.map((offer) => ({
          ...offer,
          name: decodeHtmlEntities(offer.name),
        }))

        return data
      },
      keepPreviousData: true,
      ...options,
    },
  )

  return { query }
}
